import { render, staticRenderFns } from "./hotels_map.vue?vue&type=template&id=1be1b82a&"
import script from "./hotels_map.vue?vue&type=script&lang=js&"
export * from "./hotels_map.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports